'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren, useState } from 'react';

const ReactQueryProvider = ({ children }: PropsWithChildren) => {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false,
          // Disable hydration for SSR compatibility
          staleTime: 60 * 1000, // 1 minute
          // CRITICAL FIX: Prevent queries from running during hydration
          // This prevents the infinite loading issue on first access
          refetchOnMount: 'always',
          // Add network status handling
          networkMode: 'online',
          // Prevent background refetches during initial load
          refetchInterval: false,
          refetchIntervalInBackground: false,
        },
      },
    }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};

export default ReactQueryProvider;
